import * as Sentry from '@sentry/react';
import { ErrorPage } from 'pages'; // THIS IS CIRCULAR
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

interface ErrorBoundaryProps extends RouteComponentProps {
  children?: React.ReactElement;
}

interface ErrorBoundaryState {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  unlisten?: () => void;

  constructor (props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null,
    };
  }

  componentDidMount () {
    const { history } = this.props;
    const { error } = this.state;

    this.unlisten = history.listen(() => {
      if (error) {
        this.setState({
          error: null,
          errorInfo: null,
        });
      }
    });
  }

  componentWillUnmount () {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  componentDidCatch (error: Error, errorInfo: React.ErrorInfo) {
    Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } });
    this.setState({ error, errorInfo });
  }

  render () {
    const { error, errorInfo } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <ErrorPage error={error} errorInfo={errorInfo}/>
      );
    }

    return children;

  }
}

export default withRouter(ErrorBoundary);
